// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1aio1","footer":"ReportModalFilter_footer__1Pl3n"};